module.exports = __webpack_public_path__ + "images/avatars/female/8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/8.png
// module id = v+uJ
// module chunks = 154